export const GENERAL_ROUTE = {
  name: 'General',
  path: 'general',
};
